import React from "react"
import { useNavigate } from "react-router-dom";
import { useLocation } from 'react-router-dom';
import { useParams } from 'react-router-dom';
import { isNull, isEqual, isArray } from "lodash";

import {cloneObject, getParam} from '../utils/utils';
import {getEntity, listEntities, listLogicalModels} from '../utils/utilsLogicalModel';

import dsd from '../classes/clsDSD';

import * as PD from '../classes/pdStyle';

import Buffering from "../components/Buffering"; 



class SelectEntity extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            renderState: null
        };

        this.dsd = new dsd();

        this.handleChange = this.handleChange.bind(this);
    
    }

    componentDidMount(){

        this.setup();
 
     }
 
     componentDidUpdate(prevProps, prevState){
 
        if (!isEqual(this.props, prevProps)){
            this.setup();
        }

    }
 

    setup(){

        let StateChange = {
            renderState: null,
            selectLogicalModel: false,
            label: "Entity",
            idSelected: "",
            idLogicalModel: null,
            onChange: null,
        }

        StateChange.name = getParam('name', this.props);

        if (getParam('label',this.props)){
            StateChange.label = getParam('label',this.props);
        }

        StateChange.selectLogicalModel = getParam('selectLogicalModel',this.props);
        StateChange.idLogicalModel = getParam('idLogicalModel', this.props);
        StateChange.idSelected = getParam('value', this.props);

        StateChange.onChange = getParam('onChange', this.props);

        
        if (StateChange.selectLogicalModel){
            this.loadLogicalModels();
        }

        if (StateChange.idLogicalModel){
            this.loadEntities(StateChange.idLogicalModel);
        }

        if (StateChange.idSelected){
            this.loadSelectedEntity(StateChange.idSelected);
        }

        this.setState(StateChange);

    }

    loadSelectedEntity(idEntity){

        if (!idEntity){
            return;
        }

        this.setState({renderState: "loading"});

        const onLoad = (entity) => {
            const StateChange = {
                SelectedEntity: entity,
                renderState: "loaded"
            };
            
            if (entity.LogicalModel){
                StateChange.idLogicalModel = entity.LogicalModel._id;
                this.loadEntities(StateChange.idLogicalModel);
            }
            
            this.setState(StateChange);
            
        };

        const onFail = (error) => {
            this.setState({
                renderState: "failed",
                errorMessage: error.message || "Failed to load entity"
            });
        };

        getEntity(this.dsd, idEntity, onLoad, onFail);
        
    };



    loadEntities(idLogicalModel){

        if (!idLogicalModel){
            return;
        }

        this.setState({renderState: "loading"});

        const onLoad = (entities) => {
            this.setState({
                Entities: entities,
                renderState: "loaded"
            });
        };

        const onError = (error) => {
            this.setState({
                renderState: "failed",
                errorMessage: error.message || "Failed to load entities"
            });
        };

        listEntities(this.dsd, {idLogicalModel: idLogicalModel}, onLoad, onError);
        
    };


    loadLogicalModels(){

        this.setState({renderState: "loading"});

        const onLoad = (logicalModels) => {
            this.setState({
                LogicalModels: logicalModels,
                renderState: "loaded"
            });
        };

        const onError = (error) => {
            this.setState({
                renderState: "failed",
                errorMessage: error.message || "Failed to load logical models"
            });
        };

        listLogicalModels(this.dsd, {}, onLoad, onError);
        
    };



    handleChange(event) {

        const FormFieldName = event.target.name;
        let FormFieldValue = event.target.value;

        if (event.target.type == "checkbox"){
            FormFieldValue = event.target.checked;
        }

        switch (FormFieldName){
            case "idLogicalModel":
                this.setState({"idLogicalModel":FormFieldValue});
                if (FormFieldValue){
                    this.loadEntities(FormFieldValue);
                }
                break;
            default:
                let FormData = this.state.FormData;
                FormData[FormFieldName] = FormFieldValue;
                this.setState({"FormData": FormData});
                break;
        };

    };


    render() {

        switch (this.state.renderState){
            case "invalid":
            case "failed":
            case "denied":
                let Message = "An error has occured";
                if (this.state.errorMessage){
                    Message = this.state.errorMessage;
                }
                return <PD.ErrorBox>{Message}</PD.ErrorBox>
                break;
            case "loading":
                return <Buffering/>
                break;
            case "cancelled":
                return <p>Cancelled</p>
                break;
            case "loaded":

                return(
                    <>                    

                        {this.state.selectLogicalModel && this.state.LogicalModels &&
                            <PD.Select label='Select a Logical Model' name='idLogicalModel' onChange={this.handleChange} value={this.state.idLogicalModel}>
                                {
                                    this.state.LogicalModels.map(
                                        (LogicalModel, pos) => 
                                            {
                                                return(
                                                    <option key={pos} value={LogicalModel._id}>{LogicalModel.name}</option>
                                                )
                                            }
                                    )
                                }
                            </PD.Select>
                        }


                        {this.state.Entities &&

                            <PD.Select label={this.state.label} name={this.state.name} onChange={this.state.onChange} value={this.state.idSelected}>
                                {
                                    this.state.Entities.map(
                                        (Entity, pos) => 
                                            {
                                                return(
                                                    <option key={pos} value={Entity._id}>{Entity.name}</option>
                                                )
                                            }
                                    )
                                }
                            </PD.Select>
                        }

                    </>
                )
        }

    }
}

export default function SelectEntity_wrapper(props) {
    
    const navigation = useNavigate();
    const location = useLocation();
    const params = useParams();

    return <SelectEntity {...props} navigation={navigation} location={location} params={params} />;
  }
